'use strict';

const Backbone = require('backbone');

const PageIndex = require('pages/PageIndex/PageIndex');

module.exports = Backbone.Router.extend({

    routes: {
        '*n': 'index'
    },

    initialize: function () {

    },

    index: function () {
        if (this.indexPage) {
            return;
        }
        this.indexPage = new PageIndex({router: this});
    },

    start: function () {
        Backbone.history.start({
            root: '/',
            silent: false
        });
    }
});
